import { OrderHeaderURLs } from '../../../../baseComponents/TwinTable/InputTableLayout/types'

const useSellInvoiceHeaderUrls = () => {
    const orderHeaderURLs: OrderHeaderURLs = {
        createCost: '/api/app/order/sell/sellInvoice/orderCost/createSellInvoiceCost',
        updateCost: '/api/app/order/sell/sellInvoice/orderCost/updateSellInvoiceCost',
        deleteCost: '/api/app/order/sell/sellInvoice/orderCost/deleteSellInvoiceCost',
        createFinancialRow: '/api/app/order/sell/sellInvoice/orderFinancialRow/createSellInvoiceFinancialRow',
        updateFinancialRow: '/api/app/order/sell/sellInvoice/orderFinancialRow/updateSellInvoiceFinancialRow',
        deleteFinancialRow: '/api/app/order/sell/sellInvoice/orderFinancialRow/deleteSellInvoiceFinancialRow',
        createAccount: '/api/app/order/sell/sellInvoice/orderAccount/createSellInvoiceAccount',
        updateAccount: '/api/app/order/sell/sellInvoice/orderAccount/updateSellInvoiceAccount',
        deleteAccount: '/api/app/order/sell/sellInvoice/orderAccount/deleteSellInvoiceAccount',
        createShipping: '/api/app/order/sell/sellShipping/createSellInvoiceShipping',
        updateShipping: '/api/app/order/sell/sellShipping/updateSellInvoiceShipping',
        createVariable: '/api/app/order/sell/sellInvoice/orderVariable/createSellInvoiceVariable',
        updateVariable: '/api/app/order/sell/sellInvoice/orderVariable/updateSellInvoiceVariable',
        deleteVariable: '/api/app/order/sell/sellInvoice/orderVariable/deleteSellInvoiceVariable',
        updateWorkingCenter: '/api/app/order/sell/sellInvoice/updateSellInvoiceWorkingCenter',
        createUpdateProductTypes: '/api/app/order/sell/sellInvoice/orderProductType/createUpdateSellInvoiceProductTypes',
    }
    return orderHeaderURLs
}

export default useSellInvoiceHeaderUrls